import {
  MonarchTestHook,
  MonarchTestResult,
} from "@/monarch/useMonarchTestResult";
import type { CheckoutGeoPricingTestData } from "@/lib/checkout-geo-pricing/types";

export type { CheckoutGeoPricingTestData } from "@/lib/checkout-geo-pricing/types";

export const CHECKOUT_GEO_PRICING_RULE_ID = "checkoutGeoPricingTest";

export type CheckoutGeoPricingVariant = "control" | "test";

export type CheckoutGeoPricingResult = MonarchTestResult<
  CheckoutGeoPricingVariant,
  CheckoutGeoPricingTestData
>;

export type UseCheckoutGeoPricing = MonarchTestHook<
  CheckoutGeoPricingVariant,
  CheckoutGeoPricingTestData
>;
